import {
  FaAngleLeft,
  FaCaretUp,
  FaChevronLeft,
  FaChevronRight,
  FaHeart,
  FaPlay,
  FaRegHeart,
  FaSearchPlus,
} from 'react-icons/fa';
import { IoIosCheckmarkCircle, IoLogoAndroid, IoMdClose, IoMdNotifications } from 'react-icons/io';
import { FaBars } from 'react-icons/fa';
import { IoIosCloseCircleOutline } from 'react-icons/io';
import { RxCross2 } from 'react-icons/rx';
import { FaEye } from 'react-icons/fa';
import { FaEyeSlash } from 'react-icons/fa';
import { FaHome } from 'react-icons/fa';
import { BiLoaderCircle } from 'react-icons/bi';
import { FaHandPointDown } from 'react-icons/fa';
import { FaSignInAlt } from 'react-icons/fa';
import { FaLock } from 'react-icons/fa';
import { VscTriangleDown } from 'react-icons/vsc';
import { FiCalendar } from 'react-icons/fi';
import { FiArrowLeft } from 'react-icons/fi';
import { PiKeyFill } from 'react-icons/pi';
import { PiKeyDuotone } from 'react-icons/pi';
import { MdLiveTv, MdLockOutline } from 'react-icons/md';
import { FaDice } from 'react-icons/fa';
import { FaCaretDown } from 'react-icons/fa';
import { FaPlusSquare, FaMinusSquare } from 'react-icons/fa';
import { ImCross } from 'react-icons/im';
import { LuLoaderCircle, LuSearch, LuCopy } from 'react-icons/lu';
import { IoCloseCircle, IoSettingsOutline } from 'react-icons/io5';
import { AiFillPushpin } from 'react-icons/ai';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
export const Icons = {
  circleCheck: IoIosCheckmarkCircle,
  arrowUp: FaChevronUp,
  left: FaAngleLeft,
  arrowDown: FaChevronDown,
  pin: AiFillPushpin,
  lock: MdLockOutline,
  notification: IoMdNotifications,
  clearSearch: IoCloseCircle,
  angularLeftArrow: FaChevronLeft,
  loader: LuLoaderCircle,
  stakeSettings: IoSettingsOutline,
  close: IoMdClose,
  fillHeart: FaHeart,
  playButton: FaPlay,
  outlineHeart: FaRegHeart,
  search: LuSearch,
  Android: IoLogoAndroid,
  SearchPlus: FaSearchPlus,
  Down: FaChevronDown,
  Up: FaChevronUp,
  Menu: FaBars,
  PlusSquare: FaPlusSquare,
  MinusSquare: FaMinusSquare,
  Close: IoIosCloseCircleOutline,
  Tv: MdLiveTv,
  Cross: RxCross2,
  Eye: FaEye,
  EyeSlash: FaEyeSlash,
  Home: FaHome,
  Loading: BiLoaderCircle,
  PointDown: FaHandPointDown,
  SignIn: FaSignInAlt,
  Lock: FaLock,
  TriangleDown: VscTriangleDown,
  Calendar: FiCalendar,
  Back: FaChevronLeft,
  Forward: FaChevronRight,
  ArrowLeft: FiArrowLeft,
  Key: PiKeyFill,
  KeyOutline: PiKeyDuotone,
  Dice: FaDice,
  CaretDown: FaCaretDown,
  CaretUp: FaCaretUp,
  Cross2: ImCross,
  copy: LuCopy,
};
